import axios from 'axios';

export default axios.create({
    baseURL: (window.location.href.includes("test") || window.location.href.includes("local")) ? "http://api.oneplus.dev.br" : "http://api.oneplus.dev.br"
});